module.exports = __webpack_public_path__ + "img/EEECFB_BFB6D5_D0C8EB_CCC4DC-256px.9ee550f0.png";